import { render, staticRenderFns } from "./BroadcastPublisherAssignMessage.vue?vue&type=template&id=e77d4190&scoped=true&"
import script from "./BroadcastPublisherAssignMessage.vue?vue&type=script&lang=js&"
export * from "./BroadcastPublisherAssignMessage.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPublisherAssignMessage.vue?vue&type=style&index=0&id=e77d4190&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77d4190",
  null
  
)

export default component.exports